import firebase from "firebase/app";
import "firebase/auth";
import "firebase/database";
import "firebase/storage";
import {APP_ENV, FIREBASE_CONFIG} from "./redux/constants";

console.log(APP_ENV);

firebase.initializeApp(FIREBASE_CONFIG);

export const firebaseDatabase = firebase.database();
export const firebaseAuth = firebase.auth();
export const firebaseStorage = firebase.storage();
export const SERVER_TIMESTAMP = firebase.database.ServerValue.TIMESTAMP;
